<template>
  <div id="order-detail">
    <div class="order-track">
      <template v-if="trackInfos && trackInfos.length">
        <div v-for="flow in trackInfos" :key="flow.id" class="track-item">
          <div>{{ flow.createTime | shortTimeFmt }}</div>
          <div></div>
          <div>{{ flow.content }}<span v-if="flow.operator">({{ flow.operator }})</span></div>
        </div>
        <div class="track-item">
          <div>{{ order.createTime | shortTimeFmt }}</div>
          <div></div>
          <div>{{ order.memo || '创建订单' }}</div>
        </div>
      </template>
      <template v-else>
        <div style="color: #9c9c9c;">暂无跟单信息</div>
      </template>
      <div class="actions">
        <el-button v-if="order.state === -1" v-uac="'systemtool.orderRecover'" data-uac="systemtool.orderRecover$$系统工具.取消订单恢复" size="mini" type="danger" @click="orderRecoverHandler">恢复订单</el-button>
        <el-button v-if="order.state === 1 && !order.approved" size="mini" type="warning" @click="startApproval">发起企微审批</el-button>
        <el-button size="mini" type="primary" @click="handleAddTrack">添加跟单</el-button>
      </div>
    </div>
    <div class="order-summary row">
      <div class="col-md-12">
        <div class="order-info">
          <div class="title">订单信息</div>
          <div class="field">
            <label>订单编号</label>
            <div>{{ order.sn }}</div>
          </div>
          <div v-if="order.timePay" class="field">
            <label>付款时间</label>
            <span>{{ order.timePay | dateTimeFmt }}</span>
          </div>
          <div v-else class="field">
            <label>下单时间</label>
            <span>{{ order.createTime | dateTimeFmt }}</span>
            <el-button v-if="order.state === 2" type="text" style="margin-left: 10px;padding: 0;" @click="showUmsQrCode(order)">收款码</el-button>
          </div>
          <div class="field">
            <label>订单类型</label>
            <span>{{ order.partFrom | partFromFmt }}</span>
          </div>
          <div class="field">
            <label>买家信息</label>
            <span>{{ order.subSellerName }}/</span>
            <span v-if="order.buyer">
              {{ order.buyer.companyName }}/
              {{ order.buyer.passportName }}/
              {{ phoneShow(order.buyer.passportPhone) }}
            </span>
          </div>
          <div class="field">
            <label>物流要求</label>
            <span>{{ order.express }}</span>
          </div>
          <div class="field">
            <label>发货要求</label>
            <span>{{ order.isUnifiedDelivery ? '到齐发货' : '先到先发' }}</span>
          </div>
          <div class="field">
            <label>买家留言</label>
            <span>{{ order.memo }}</span>
          </div>
          <div class="field">
            <label>优惠信息</label>
            <span v-if="order.couponAmount" style="margin-right: 14px">优惠券：{{ order.couponAmount.toFixed(2) }}</span>
            <span v-if="order.reductionAmount" style="margin-right: 14px">满减优惠：{{ order.reductionAmount.toFixed(2) }}</span>
            <span v-if="order.beanExchange" style="margin-right: 14px">云豆：{{ (order.beanExchange / 100).toFixed(2) }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="delivery-info">
          <div class="title">配送信息</div>
          <template v-if="order.deliveries && order.deliveries.length">
            <template v-for="(sub, idx) in order.deliveries">
              <div :key="`type_${sub.id}`" class="field">
                <label>实际配送</label>
                <span>{{ sub.deliveryType | deliveryTypeFmt }}</span>
              </div>
              <div :key="`delivery_${sub.id}`" class="field packages">
                <label>发货信息</label>
                <div class="cont">
                  <div :key="sub.id" class="package">
                    <span style="color:#409EFF; cursor: pointer;" @click="showPackageInfo(sub.id)">【包裹{{ idx + 1 }}】</span>
                    <template v-if="sub.deliveryType===1 || sub.deliveryType === 3">
                      {{ sub.logisticsCompany }} / {{ sub.logisticsSn }}
                    </template>
                    <template v-else-if="sub.deliveryType===2">
                      {{ sub.driverInfo }}
                    </template>
                    <template v-else-if="sub.deliveryType===4">
                      {{ [sub.pickupInfo,sub.pickupTime&& '自提时间：' + dateFmt(sub.pickupTime)].filter(e=>e).join('/') }}
                    </template>
                    <template v-else>
                      {{ sub.expressInfo }}
                    </template>
                    <template v-if="sub.estimatedArrivalTime">
                      / 预计{{ sub.estimatedArrivalTime || shortDateFmt }}送达
                    </template>
                    <div v-if="sub.operatorName">发货人：{{ sub.operatorName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ sub.createTime | shortTimeFmt }}</div>
                    <delivery-attachment-shower v-if="sub.images && sub.images.length" :urls="sub.images" />
                  </div>
                </div>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="field">
              <label>实际配送</label>
              <span class="val">--</span>
            </div>
            <div class="field">
              <label>发货信息</label>
              <span class="val">--</span>
            </div>
          </template>
          <div class="field">
            <label>运费信息</label>
            <span v-if="order.isFreightCollect">
              到付
            </span>
            <span>
              <template v-if="order.carriage">
                {{ order.carriage | currencyFmt }}
              </template>
              ({{ (order.carriageMemo || '运费请与买家协商后确定') }})
            </span>
          </div>
          <div class="field">
            <label>收货人</label>
            <span v-if="order.nameAddressee || order.phoneAddressee || order.addressAddressee" class="cont">
              {{
                [
                  order.nameAddressee,
                  order.phoneAddressee,
                  (order.addressAddressee || '').replace(/-/g, '')
                ].filter(e=>e).join(' / ') || ''
              }}
            </span>
            <span v-else>
              --
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="actions-header">
      <div class="left">
        <!-- <el-checkbox v-model="waitingDeliveryOnly">仅显示待发</el-checkbox> -->
        <el-radio v-model="itemSort" size="small" :label="2">编号排序</el-radio>
        <el-radio v-model="itemSort" size="small" :label="1">名称排序</el-radio>
      </div>
      <div class="right">
        <el-input v-if="(order.orderItems || []).length > 5" v-model="keywords" size="small" placeholder="编号/名称搜索" />
        <el-button type="warning" size="small" style="margin-left: 6px;" @click="doExp">导出</el-button>
      </div>
    </div>
    <div class="headers">
      <div class="row" :style="{ paddingRight: hasScroll ? 10 + scrollBarWidth + 'px' : 'px' }">
        <div class="col-sm-1">类型</div>
        <div class="col-sm-1">品牌</div>
        <div class="col-sm-3">编号</div>
        <div class="col-sm-2">名称</div>
        <div class="col-sm-2">发货地</div>
        <div class="col-sm-2">单价</div>
        <div class="col-sm-2">4S进价</div>
        <div class="col-sm-4">下单数量</div>
        <div class="col-sm-2">售后数量</div>
        <div class="col-sm-2">已发数量</div>
        <div class="col-sm-3">待发数量</div>
      </div>
    </div>
    <div ref="dataList" class="part-list">
      <div v-for="(part, idx) in (filterParts || order.orderItems)" :key="idx" class="part-item-wraper">
        <div class="part-item row">
          <div class="info-item col-sm-1">
            <label>类型</label>
            <div>
              <span v-if="part.priceType === 0" class="badge">常规件</span>
              <span v-if="part.priceType === 1" class="badge">急件</span>
              <span v-if="part.priceType === 2" class="badge">海外件</span>
              <span v-if="part.priceType === 3" class="badge">兆配现货</span>
              <span v-if="part.priceType === 4" class="badge">4S现货</span>
              <span v-if="part.isSpot" class="badge">极速达</span>
              <span v-if="part.isPromoted" class="badge">特价</span>
            </div>
          </div>
          <div class="info-item col-sm-1">
            <label>品牌</label>
            <div>
              {{ part.brandName }}
            </div>
          </div>
          <div class="info-item col-sm-3">
            <label>编号</label>
            <div>
              <span v-if="part.supersession">
                新件：{{ part.supersession }}/旧件：
              </span>
              <span>{{ part.partCode }}</span>
              <span v-uac="'systemtool.ordersplit'" data-uac="systemtool.ordersplit$$系统工具.订单项拆分" class="x-link" @click="orderSplitHandler(part)">拆分</span>
              <span v-uac="'systemtool.opsrelease'" data-uac="systemtool.opsrelease$$系统工具.采购释放" class="x-link" @click="opsReleaseHandler(part)">释放</span>
            </div>
          </div>
          <div class="info-item col-sm-2">
            <label>名称</label>
            <div>
              {{ part.partName }}
            </div>
          </div>
          <div class="info-item col-sm-2">
            <label>发货地</label>
            <div>{{ part.warehouse }}</div>
          </div>
          <div class="info-item col-sm-2">
            <label>单价</label>
            <div>
              <span>{{ part.taxed ? '含税价' : '税前价' }}</span><span>{{ part.price }}</span>
            </div>
          </div>
          <div class="info-item col-sm-2">
            <label>4S进价</label>
            <div>{{ part.cost4S }}{{ part | discountFmt }}</div>
          </div>
          <div class="info-item col-sm-4">
            <label>下单数量</label>
            <div>
              {{ part.quantity }}
              <official-stock-list-popover v-if="order.state < 6 && order.state > 2 && part.stockInfos" :stock-infos="part.stockInfos"></official-stock-list-popover>
              &nbsp;
              <item-source v-if="order.timePay && (part.itemSources || []).length > 0" :order-item="part"></item-source>
            </div>
          </div>
          <div class="info-item col-sm-2">
            <label>售后数量</label>
            <div>
              <a v-if="part.quantityReturn > 0" href="javascript: void(0);" @click="showReturn(part.id)">{{ part.quantityReturn }}</a>
              <span v-else>--</span>
            </div>
          </div>
          <div class="info-item col-sm-2">
            <label>已发数量</label>
            <div>
              <a href="javascript: void(0);" @click="showDelivery(part.id)">{{ part.quantityDelivered }}</a>
            </div>
          </div>
          <div class="info-item col-sm-3">
            <label>待发数量</label>
            <div>
              <span style="width: 24px; display: inline-block;">{{ part.quantity - part.quantityReturn - part.quantityDelivered }}</span>
              <item-deliverable v-if="order.timePay && (part.itemSources || []).length > 0" :order-item="part"></item-deliverable>
              <ops-view-popover
                v-else-if="order.state === 3 && part.opsInfo && (part.quantity - part.quantityReturn - part.quantityDelivered > 0)"
                :ops-info="part.opsInfo"
                :current-order-id="order.id"
                :wait-delivery="part.quantity - part.quantityReturn - part.quantityDelivered"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="statitics">
      共计{{ order.orderItems.length }}种，
      {{ order.orderItems.reduce((s, i) => s + i.quantity, 0) }}件配件，
      总金额 {{ order.orderItems.reduce((s, i) => s + i.quantity * i.price, 0).toLocaleString() }}
      {{ couponAmount ? `，优惠券抵扣：${(couponAmount.toLocaleString())}`: '' }}
      {{ beanExchange ? `，云豆抵扣：${(beanExchange.toLocaleString())}`: '' }}
    </div>
  </div>
</template>
<script>
import { DetailOrder, LoadOpsInfo, OrderItemStockInfo, AddTrackInfo, UmsPlaceOrder, ExportOrder, OrderRecover, OpsRelease, LoadSourceInfo } from './services.js'
import OpsViewPopover from './partials/OpsViewPopover'
import ItemSource from './partials/ItemSource.vue'
import ItemDeliverable from './partials/ItemDeliverable.vue'
import DeliveryAttachmentShower from './partials/DeliveryAttachmentShower.vue'
import OfficialStockListPopover from './partials/OfficialStockListPopover.vue'
import { bind, unbind } from '@/utils/eventBinder.js'
import _ from 'lodash'
import moment from 'moment'
import Config from '@/config'

export default {
  name: 'OrderDetail',
  components: {
    ItemSource,
    ItemDeliverable,
    OpsViewPopover,
    DeliveryAttachmentShower,
    OfficialStockListPopover
  },
  filters: {
    discountFmt (orderItem) {
      if (orderItem.cost4S) {
        // eslint-disable-next-line no-eval
        return '（' + eval(Math.round((orderItem.price * 100) / orderItem.cost4S) + 'e-1') + '折）'
      }
      return ''
    },
    partFromFmt (val) {
      switch (val) {
        case 7 : return '反向订单'
        case 6 : return '大库订单'
        case 2 : return '询价订单'
        default : return '普通订单'
      }
    },
    shortTimeFmt (val) {
      return moment(val).format('MM-DD HH:mm')
    },
    deliveryTypeFmt (val) {
      switch (val) {
        case 1: return '物流发货'
        case 2: return '司机送货'
        case 4: return '上门自提'
        default: return '物流发货'
      }
    }
  },
  data () {
    return {
      loading: false,
      keywords: undefined,
      itemSort: 2,
      hasScroll: false,
      order: {
        trackInfos: [],
        orderItems: []
      },
      filterParts: undefined
    }
  },
  computed: {
    orderId () {
      return this.$route.params.id
    },
    scrollBarWidth () {
      return this.$store.state.scrollbarWidth
    },
    couponAmount () {
      return this.order.orderItems.reduce((s, i) => s + i.couponAmount, 0)
    },
    beanExchange () {
      return (this.order.orderItems.reduce((s, i) => s + i.beanExchange, 0) * 1.00 / 100)
    },
    payTypes () {
      return this.$store.state.payTypes
    },
    trackInfos () {
      const result = [...this.order.trackInfos]
      if (this.order.timePay) {
        result.push({
          content: `订单已支付，支付金额：${this.order.amountPay.toLocaleString()}，支付方式：${this.payTypes[this.order.payType]}`,
          createTime: this.order.timePay,
          id: -2
        })
      }
      if (this.order.timeDelivery) {
        result.push({
          content: `订单已发货`,
          createTime: this.order.timeDelivery,
          id: -3
        })
      }
      if (this.order.timeReceive) {
        result.push({
          content: `客户已收货`,
          createTime: this.order.timeReceive,
          id: -4
        })
      }
      if (this.order.timeCancel) {
        result.push({
          content: `订单已取消`,
          createTime: this.order.timeCancel,
          id: -5
        })
      }
      if (this.order.timeReturn) {
        result.push({
          content: `订单已退款`,
          createTime: this.order.timeReturn,
          id: -6
        })
      }
      result.forEach(item => {
        item.createTime = moment(item.createTime).format('YYYY/MM/DD HH:mm:ss')
      })
      return result.sort((a, b) => b.createTime.localeCompare(a.createTime))
    }
  },
  watch: {
    itemSort (val) {
      if (this.itemSort === 1) {
        this.order.orderItems.sort((a, b) => (a.partName || '').localeCompare(b.partName || ''))
      } else {
        this.order.orderItems.sort((a, b) => (a.partCode || '').localeCompare(b.partCode || ''))
      }
    },
    keywords (val) {
      if (val) {
        this.filterParts = this.order.orderItems.filter(t => ~t.partCode.indexOf(val) || ~t.partName.indexOf(val))
      } else {
        this.filterParts = undefined
      }
    }
  },
  beforeMount () {
    this.checkScrollBarDebounce = _.debounce(() => {
      this.checkScrollbar()
    }, 50)
  },
  mounted () {
    this.loadData()
    bind(window, 'resize', this.checkScrollBarDebounce)
  },
  beforeDestory () {
    unbind(window, 'resize', this.checkScrollBarDebounce)
  },
  methods: {
    dateFmt (val) {
      return moment(val).format('MM-DD HH:mm')
    },
    startApproval () {
      this.modal('StartApproval', this.order.sn, this.order.isBatch).promise.finally(() => {
        this.loadData()
      })
    },
    opsReleaseHandler (orderItem) {
      this.$confirm('清除采购关系', '确认').then(() => {
        OpsRelease(orderItem.id).then(() => {
          this.loadData()
        })
      })
    },
    orderRecoverHandler () {
      this.$confirm('确认恢复此订单', '确认').then(() => {
        OrderRecover(this.orderId).then(() => {
          this.loadData()
        })
      })
    },
    orderSplitHandler (orderItem) {
      this.modal('SplitOrderModal', {
        orderItemId: orderItem.id,
        sn: orderItem.partCode,
        quantity: orderItem.quantity,
        quantityDelivered: orderItem.quantityDelivered || 0
      }).promise.then(() => {
        this.loadData()
      })
    },
    showUmsQrCode (order) {
      if (_.every(order.orderItems, part => part.taxed)) {
        UmsPlaceOrder(order).then((qrCodeResp) => {
          order.qrCode = qrCodeResp.billQrCode
          this.modal('OrderQrCodeModal', order).promise.catch(() => {})
        })
      } else {
        this.modal('OrderQrCodeModal', order).promise.catch(() => {})
      }
    },
    handleAddTrack () {
      const that = this
      this.$prompt('', {
        title: '添加跟单',
        showInput: true,
        inputType: 'textarea',
        inputPattern: /\S+/,
        inputPlaceholder: '跟单内容',
        inputErrorMessage: '请输入跟单内容'
      }).then(({ value }) => {
        AddTrackInfo({ content: value, orderId: that.orderId }).then(() => {
          that.loadData()
        })
      })
    },
    showReturn (orderItemId) {
      this.modal('OrderReturnDetailModal', orderItemId).promise.catch(() => {})
    },
    showDelivery (orderItemId) {
      this.modal('OrderDeliveryDetailModal', orderItemId, this.order.deliveries).promise.catch(() => {})
    },
    showPackageInfo (deliveryId) {
      this.modal('OrderPackageDetailModal', deliveryId).promise.catch(() => {})
    },
    loadData () {
      this.loading = true
      DetailOrder(this.orderId).then(resp => {
        if (this.itemSort === 1) {
          resp.orderItems.sort((a, b) => (a.partName || '').localeCompare(b.partName || ''))
        } else {
          resp.orderItems.sort((a, b) => (a.partCode || '').localeCompare(b.partCode || ''))
        }
        this.order = resp
        this.loadStockInfoSnap(resp)
        Promise.all([
          this.loadOpsViewer([resp]),
          this.loadSourceViewer([resp])
        ]).finally(() => {
          this.$nextTick(() => {
            this.checkScrollBarDebounce()
          })
        })
      }).finally(() => {
        this.loading = false
      })
    },
    loadSourceViewer (orders) {
      const orderItemIds = []
      orders.forEach(order => {
        if (order.timePay > Config.itemSourceEffectTime) {
          orderItemIds.push(...order.orderItems.map(t => t.id))
        }
      })
      LoadSourceInfo(orderItemIds).then(resp => {
        orders.forEach(order => {
          order.orderItems.forEach(orderItem => {
            this.$set(orderItem, 'itemSources', resp.filter(t => t.orderItemId === orderItem.id))
          })
        })
      })
    },
    loadOpsViewer (orders) {
      const opsPart = [];
      (orders || []).forEach(order => {
        if (order.timePay < Config.itemSourceEffectTime) {
          order.orderItems.forEach(part => {
            if ((part.quantity - part.quantityDelivered - part.quantityReturn) > 0 && part.brandCode) {
              opsPart.push({
                brandCode: part.brandCode,
                partCode: part.supersession || part.partCode,
                quality: part.quality === '原厂件' ? 1 : 4
              })
            }
          })
        }
      })
      const toQuery = _.uniqBy(opsPart, o => `${o.brandCode}_${o.partCode}_${o.quality}`)
      const promises = []
      const opsInfoAll = []
      for (let i = 0; i < toQuery.length; i += 600) {
        const sliceQuery = toQuery.slice(i, i + 600)
        promises.push(this.sliceLoadOpsInfo(sliceQuery, opsInfoAll))
      }
      return Promise.all([...promises]).then(() => {
        orders.forEach(order => {
          order.orderItems.forEach(part => {
            if ((part.quantity - part.quantityDelivered - part.quantityReturn) > 0 && part.brandCode && order.state === 3) {
              const apiOpsInfo = _.find(opsInfoAll, o => o.brandCode === part.brandCode && o.partCode === (part.supersession || part.partCode) && o.quality === (part.quality === '原厂件' ? 1 : 4))
              if (apiOpsInfo) {
                const opsInfo = _.cloneDeep(apiOpsInfo)
                this.stockProcessed(opsInfo, order.id)
                this.$set(part, 'opsInfo', opsInfo)
              } else {
                this.$set(part, 'stock', 0)
              }
            }
          })
        })
      })
    },
    loadStockInfoSnap (orderInfo) {
      return new Promise((resolve, reject) => {
        if (orderInfo.state > 2 && orderInfo.state < 6) {
          OrderItemStockInfo([orderInfo.id]).then(resp => {
            if (resp && resp.length) {
              orderInfo.orderItems.forEach((part) => {
                const stockSnap = resp.find(o => o.orderItemId === part.id)
                const stockInfo = stockSnap && stockSnap.stockInfos ? JSON.parse(stockSnap.stockInfos) : null
                this.$set(part, 'stockInfos', stockInfo)
              })
            }
            resolve(true)
          }).catch(() => {
            resolve(true)
          })
        } else {
          resolve(true)
        }
      })
    },
    stockProcessed (opsInfo, currentOrderId) {
      opsInfo.stock.forEach(repo => {
        repo.state = this.calculateState(opsInfo, repo, currentOrderId)
        repo.stockInInfos = _.filter(opsInfo.stockInfo, o => o.shopId === repo.shopId)
      })
    },
    calculateState (opsInfo, repo, currentOrderId) {
      const sumDemand = _.sumBy(opsInfo.orderDemand, o => o.quantity - o.quantityDelivered)
      if (repo.quantity >= sumDemand) {
        return 2
      }
      const currentOrder = _.find(opsInfo.orderDemand, o => o.orderId === currentOrderId)
      if (currentOrder !== null) {
        if (repo.quantity >= (currentOrder.quantity - currentOrder.quantityDelivered)) {
          return 1
        }
      }
      return 0
    },
    sliceLoadOpsInfo (toQuery, opsInfo) {
      return LoadOpsInfo(toQuery).then((resp) => {
        if (resp && resp.length) {
          opsInfo.push(...resp)
          return resp
        } else {
          return []
        }
      })
    },
    checkScrollbar () {
      const dataList = this.$refs.dataList
      if (dataList) {
        this.hasScroll = dataList.clientHeight < dataList.scrollHeight
      } else {
        this.hasScroll = false
      }
    },
    showQrCode (order) {
      this.modal('OrderQrCodeModal', order).promise.catch(() => {})
    },
    doExp () {
      ExportOrder(this.order)
    }
  }
}
</script>
